export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_CART_AD = 'ADD_TO_CART_AD'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_ADICIONAIS = 'FETCH_ADICIONAIS'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const REMOVE_FROM_CART_AD = 'REMOVE_FROM_CART_AD'
export const DECREMENTA_QUANTIDADE = 'DECREMENTA_QUANTIDADE'
export const INCREMENTA_QUANTIDADE = 'INCREMENTA_QUANTIDADE'